import { ReferralSystem } from "@/components/ReferralSystem";

const ReferralsPage = () => {
  return (
    <div className="p-6 space-y-6">
      <div className="space-y-2">
        <h1 className="text-3xl font-bold text-foreground">Referral System</h1>
        <p className="text-lg text-muted-foreground">
          Earn rewards by referring new customers to our platform
        </p>
      </div>
      
      <ReferralSystem />
    </div>
  );
};

export default ReferralsPage;